module.exports = __webpack_public_path__ + "static/media/qr_android.8d7ed6a3.png";